import BaseUseCase from "../../../base_use_case.js";

class DeleteDeveloperUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "delete",
      url: `/api/v1/admin/projects/developers/${identifier}`,
    });
  }
}

const instance = new DeleteDeveloperUseCase();
export default instance;